// src/app/services/auth.service.ts
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable,  BehaviorSubject } from "rxjs";
import { finalize, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  private apiUrl = environment.KAPS_V1_DIRECT_URL;
  private isAuthenticatedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isAuthenticated$: Observable<boolean> = this.isAuthenticatedSubject.asObservable();

  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http.post<any>(
      `${this.apiUrl}Services/SecuritySvc.asmx/AuthenticateUser`, // Login endpoint
      { "userid": username, "password": password, "returnUrl": "" },
      { headers: headers, withCredentials: true },
    ).pipe(
      map(response => {
        if (response.d.IsAuthenticated) {
          this.isAuthenticatedSubject.next(true);
          // Store any relevant info like tokens or user details if necessary
        }
        return response;
      })
    );
  }

  logout(): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http
      .post<any>(
        `${this.apiUrl}Services/SecuritySvc.asmx/LogOffUser`,
        {},
        { headers, withCredentials: true },
      )
      .pipe(
        // Always clear local auth state even if backend logoff fails.
        finalize(() => this.isAuthenticatedSubject.next(false)),
      );
  }

  isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }
}
